import { useMutation } from '@tanstack/react-query';

import { orpc } from 'src/api/rpc/client';
import { leaveTo } from './leaveTo';

export function useApproveAuthorization() {
  return useMutation({
    ...orpc.mcpOAuth.approveAuthorization.mutationOptions(),
    onSuccess: leaveTo,
  });
}

export function useDenyAuthorization() {
  return useMutation({
    ...orpc.mcpOAuth.denyAuthorization.mutationOptions(),
    onSuccess: leaveTo,
  });
}

/** Whether the page is on its way back to the client, so buttons lock. */
export function isLeaving(
  ...mutations: { isPending: boolean; isSuccess: boolean }[]
): boolean {
  return mutations.some((mutation) => mutation.isPending || mutation.isSuccess);
}
